import './../css/main.sass'
import 'bootstrap/js/dist/carousel'
import 'bootstrap/js/dist/dropdown'
import 'bootstrap/js/dist/collapse'
import './partials/navbar.js'
import 'bcswipe'

import Vue from 'vue/dist/vue.esm'
import VueMq from 'vue-mq'
import { determineHeroImages } from './components/determineHeroImage'

let store = {
    debug: true,
    state: {
        loading: false,
        baseUrl: process.env.BACKEND_BASE_URL,
        defaultBackgroundImage: require('../assets/'+ BACKGROUNDIMAGE_FALLBACK),
        defaultFilialeIcon: require('../assets/'+ ICON_FALLBACK),        
        filiale: {},
        dealer: {},
        pictures: [],
        businessHours: [],
        specialBusinessHours: {},
        coupons: [],
        searchTags: {}
    },


    async setFiliale(filialeObject) {
        this.state.loading = true; 
        
        // replace heroImages if necessary
        filialeObject = await determineHeroImages(filialeObject);
        
        // set filiale object 
        this.state.filiale = filialeObject.basics[0]
        
        // format branches to one string and add it to filiale
        if(filialeObject.branches.length > 0) {
            this.state.filiale.branches = filialeObject.branches[0].title
        }
            // if the filiale has multiple branches seperate them with a comma
        if (filialeObject.branches.length > 1) {
            for (let i = 1; i < filialeObject.branches.length; i++) {
                this.state.filiale.branches += ", " + filialeObject.branches[i].title                
            }
        }

        // fromat businessHours
        let that = filialeObject.basics[0]
        this.state.businessHours[0] = formatTime(0,that.mo_von,that.mo_bis,that.mo_von2,that.mo_bis2)
        this.state.businessHours[1] = formatTime(1,that.di_von,that.di_bis,that.di_von2,that.di_bis2)
        this.state.businessHours[2] = formatTime(2,that.mi_von,that.mi_bis,that.mi_von2,that.mi_bis2)
        this.state.businessHours[3] = formatTime(3,that.do_von,that.do_bis,that.do_von2,that.do_bis2)
        this.state.businessHours[4] = formatTime(4,that.fr_von,that.fr_bis,that.fr_von2,that.fr_bis2)
        this.state.businessHours[5] = formatTime(5,that.sa_von,that.sa_bis,that.sa_von2,that.sa_bis2)
        this.state.businessHours[6] = formatTime(6,that.so_von,that.so_bis,that.so_von2,that.so_bis2)
        
        // add logo and heroImage too filiale from pictures
        for(let i = 0; i < filialeObject.pictures.length; i++) {
            if(filialeObject.pictures[i].type == "logo") {
                this.state.filiale.icon_url = filialeObject.pictures[i].pfad_url;
                filialeObject.pictures.splice(i, 1);
                i = i-1;
            }
            else if (filialeObject.pictures[i].type == "heroimage"){
                this.state.filiale.image_url = filialeObject.pictures[i].pfad_url;
                filialeObject.pictures.splice(i, 1);
                i = i-1;
            }
            else if (filialeObject.pictures[i].type == "map") {
                filialeObject.pictures.splice(i, 1);
                i = i-1;
            }
            else {
                this.state.pictures.push(filialeObject.pictures[i]);
            }
        }

        //assign dealer object
        this.state.dealer = filialeObject.dealer;
            
        //assign special opening hours to correct array
        this.state.specialBusinessHours = filialeObject.specialOpeningHours

        // format dates of coupons
        for (let i = 0; i < filialeObject.coupons.length; i++) {
            let parts = filialeObject.coupons[i].gueltig_von.split('-')
            filialeObject.coupons[i].gueltig_von = parts[2] +'.'+ parts[1]+'.'+ parts[0]
            parts = filialeObject.coupons[i].gueltig_bis.split('-')
            filialeObject.coupons[i].gueltig_bis = parts[2] +'.'+ parts[1]+'.'+ parts[0]
        }
        this.state.coupons = filialeObject.coupons
        this.state.searchTags = filialeObject.searchTags
        this.state.loading = false;
    },    
}

Vue.use(VueMq, {
    breakpoints: {
        mobile: 790,
        tablet: 1320,
        desktop: Infinity,
    }
})

let body = new Vue({
    el: '#vendor-body',
    data: store.state,
    methods: {
        getCollapsibleId: function(idx, prepend = '') {
            return prepend + "bCollapsible" + idx
        },
        escapeHTML: function(unsafeText) {
            return encodeURIComponent(unsafeText)
        },
        contactOpeningSwitch(target){
            let contact = $('#divContactSwitch')
            let hours = $('#divBusinessHoursSwitch')

            if(target == "contact"){
                contact.addClass('busi-contact-active')
                contact.removeClass('busi-contact-inactive')

                hours.addClass('busi-business-hours-inactive')
                hours.removeClass('busi-business-hours-active')

                $('#contact-div').show()
                $('#business-hours-div').addClass('d-none')
            } else if(target == "hours"){
                contact.addClass('busi-contact-inactive')
                contact.removeClass('busi-contact-active')
                    
                hours.addClass('busi-business-hours-active')
                hours.removeClass('busi-business-hours-inactive')
                    
                $('#contact-div').hide()
                $('#business-hours-div').removeClass('d-none')
            }
        }
    },
    computed: {
        mailtoLink: function() {
            return "mailto:" + store.state.filiale.filiale_email;
        },
        websiteLink: function() {
            return store.state.filiale.filiale_website;
        },
        mapsEmbeddedUrl: function() {
            let v = store.state.filiale;
            return "https://maps.google.com/maps?q=" + v.filiale_breitengrad + "," + v.filiale_laengengrad + "&hl=es;z=14&output=embed";
        },
        mapsUrl: function() {
            let v = store.state.filiale;
            return "https://maps.google.com/maps?q=" + v.filiale_breitengrad + "," + v.filiale_laengengrad + "&hl=es;z=14";
        },
        phoneLink: function() {
            if (store.state.filiale.filiale_tel !== undefined && store.state.filiale.filiale_tel !== null)
                return "tel:" + store.state.filiale.filiale_tel.replace(/[^0-9]/g, "")
            return '#'
        }
    },
    mounted(){
        window.addEventListener('scroll', function() {
            if ($(this).scrollTop() >= 50) {
                $('#backToTop').fadeIn(200);
                $('.cookie-data').addClass('cookie-data-animation')
                $(".navbar-style-dark").find(".navbar").addClass("nav-solid");
    
            } else {
                $('#BackToTop').fadeOut(200);
                $('.cookie-data').removeClass('cookie-data-animation')
                $(".navbar-style-dark").find(".navbar").removeClass("nav-solid");
            }
        });

        $('#backToTop').click(function() {
            $('body,html').animate({
                scrollTop: 0
        }, 500);});
    }    
})


$(document).ready(function() {
    $('#vendor-body .carousel').bcSwipe({ threshold: 50 });
});

function fetchFilialeData(filialeName) {
    fetch(process.env.BACKEND_BASE_URL + "/api/filialen/" + filialeName)
        .then(response => response.json())
        .then(async json => {
            await store.setFiliale(json);
            let div = findGetParameter("section")
            if(div != null && div.length > 0){
                $('html, body').animate({ scrollTop: $('#'+div).offset().top - 80}, 2000)
            }
        })
}

// helper function to create an iteratable array with the opening hours 
function formatTime(weekDay, von, bis, von2, bis2) {
    let days = ["Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag", "Sonntag"]
    let day = days[weekDay]
    let text = "";
    if (von != null && von != undefined) {
        if(bis != null && bis != undefined) {
            text = von.slice(0, -3) + ' - ' + bis.slice(0, -3) + ' Uhr'
        } else {
            text = von.slice(0, -3)
        }
    } else {
        text = "geschlossen"
    }
    if (von2 !== null && von2 !== undefined) {
        let text2 = ', ' + von2.slice(0, -3) + ' - ' + bis2.slice(0, -3) + ' Uhr'
        text = text + text2
    }
    let formattedString = { day: day, text: text }
    return formattedString
}

function findGetParameter(parameterName) {
    let result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function(item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

if (process.env.NODE_ENV === "development" || process.env.NODE_ENV === "staging" || process.env.NODE_ENV === 'production') {
    let name = findGetParameter("filiale")    
    
    if (name != null && name.length > 0) {
        fetchFilialeData(name)
    } else {
        window.location.replace("index.html")
    }    

} else {
    console.error("No content loading for this build mode defined.")
}

window.addEventListener("load", function(){
    $('#business-body').removeClass('donot-display');
});

$('#cookie-bot-btn').unbind('click');
$('#cookie-bot-btn').click(function() {
    $('#cookie-data-wrap').toggleClass('donot-display');
});